import { render, staticRenderFns } from "./customer_loader.vue?vue&type=template&id=37996e18&scoped=true&"
import script from "./customer_loader.vue?vue&type=script&lang=js&"
export * from "./customer_loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37996e18",
  null
  
)

export default component.exports